// comment-api — 文章评论(2026-06-12 spec §4.1)
//
// 路由(server/internal/httpapi/comment_handlers.go):
//   GET  /gapi/user/articles/{article_id}/comments?offset=&limit=
//   POST /gapi/user/articles/{article_id}/comments  {content}

import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@dogdisk/shared'

export type CommentRow = {
  id: string
  user_id: string
  nickname: string
  avatar: string | null
  content: string
  created_at: string
}

export type CommentPage = { items: CommentRow[]; total: number }

const listKey = (articleId: string) => ['comments', articleId] as const

// enabled:调用方可传 isLoggedIn——GET comments 在 guarded 段,匿名访问文章页
// 不发请求(否则 401 → 全局"登录已失效"toast 噪声),评论区直接显示空态。
export function useArticleComments(articleId: string | null, offset: number, limit = 20, enabled = true) {
  return useQuery({
    queryKey: [...listKey(articleId ?? ''), offset, limit] as const,
    enabled: enabled && Boolean(articleId),
    placeholderData: keepPreviousData,
    queryFn: () =>
      apiClient.get<CommentPage>(
        `/gapi/user/articles/${encodeURIComponent(articleId!)}/comments?offset=${offset}&limit=${limit}`,
      ),
  })
}

export function usePostComment(articleId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (content: string) =>
      apiClient.post<CommentRow>(
        `/gapi/user/articles/${encodeURIComponent(articleId)}/comments`,
        { content },
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: listKey(articleId) })
      void qc.invalidateQueries({ queryKey: ['social', 'stats', 'article', articleId] })
    },
  })
}
